import { render, staticRenderFns } from "./ProgramSidebar.vue?vue&type=template&id=477b33f4&"
import script from "./ProgramSidebar.vue?vue&type=script&lang=js&"
export * from "./ProgramSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports